import { api } from '@/shared/api/client-api'
import { API_END_POINTS } from '@/shared/api/end-points'
import { GetProjectFilesDto, GetProjectMembersResponse } from '../../lib/types'
import { projectMembersMappers } from '../../lib'

const getprojectmembers = async (params: GetProjectFilesDto) => {
  const res = await api.json<GetProjectMembersResponse>(API_END_POINTS.project.getProjectMembers(params))
  if (res.ok) return projectMembersMappers.mapProjectMembers(res.result || {})
  if (!res.ok) throw new Error(res?.message || res?.error)
}

export default getprojectmembers
